import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import AppRoutes from './routes/AppRoutes';
import AuthSessionManager from './components/auth/AuthSessionManager';
import SplashScreen from './components/common/SplashScreen';
import './styles/App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <AuthSessionManager />
          <SplashScreen />
          <AppRoutes />
          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={10}
            containerStyle={{ top: 18, right: 18 }}
            toastOptions={{
              duration: 4200,
              style: {
                minWidth: '320px',
                maxWidth: '420px',
                background: 'rgba(255, 255, 255, 0.98)',
                color: '#0b1f3a',
                border: '1px solid rgba(203, 213, 225, 0.9)',
                borderRadius: '8px',
                boxShadow: '0 18px 44px rgba(15, 23, 42, 0.10)',
                padding: '13px 15px',
                fontFamily: 'Inter, system-ui, sans-serif',
                fontSize: '13px',
                fontWeight: 500,
                lineHeight: 1.45,
              },
              success: {
                duration: 3200,
                iconTheme: {
                  primary: '#0ea4f9',
                  secondary: '#ffffff',
                },
              },
              error: {
                duration: 5200,
                iconTheme: {
                  primary: '#dc2626',
                  secondary: '#ffffff',
                },
              },
              loading: {
                iconTheme: {
                  primary: '#0b1f3a',
                  secondary: '#ffffff',
                },
              },
            }}
          />
  
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
